// ============================================================================
// Entity: Absences
// Key: absences
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	absencesCreate,
	absencesDelete,
	absencesUpdate,
	getAbsencesListQueryKey,
	getAbsencesListQueryOptions,
} from '../api/backstage'
// #region Imports
import type {
	CreateAbsenceRequest,
	PagedResultOfAbsenceDetails,
	UpdateAbsenceRequest,
} from '../api/backstage.schemas'
import type { EntityConfig, ListQueryParams } from './entity-config.types'
import {
	defineMutationEndpoint,
	defineQueryEndpoint,
} from './entity-config.types'

// #endregion

// #region Entity Endpoints
const absencesEntityEndpoints = {
	create: defineMutationEndpoint<
		PagedResultOfAbsenceDetails,
		CreateAbsenceRequest,
		undefined
	>({
		key: 'absences.create',
		method: 'POST',
		path: '/admin/absences',
		mutationOptions: () => ({
			mutationFn: (variables: { data: CreateAbsenceRequest }) =>
				absencesCreate(variables.data),
		}),
		invalidates: [(_context) => getAbsencesListQueryKey()],
	}),
	delete: defineMutationEndpoint<void, undefined, { absencesId: number }>({
		key: 'absences.delete',
		method: 'DELETE',
		path: '/admin/absences/{absencesId}',
		pathParams: ['absencesId'] as const,
		mutationOptions: () => ({
			mutationFn: (variables: {
				absencesId: number | string | null | undefined
			}) => absencesDelete(variables.absencesId),
		}),
		invalidates: [(_context) => getAbsencesListQueryKey()],
	}),
	list: defineQueryEndpoint<
		PagedResultOfAbsenceDetails,
		undefined,
		ListQueryParams
	>({
		key: 'absences.list',
		method: 'GET',
		path: '/admin/absences',
		queryKey: (args) => getAbsencesListQueryKey(args?.queryParams),
		queryOptions: (args) => getAbsencesListQueryOptions(args?.queryParams),
	}),
	update: defineMutationEndpoint<
		PagedResultOfAbsenceDetails,
		UpdateAbsenceRequest,
		{ absencesId: number }
	>({
		key: 'absences.update',
		method: 'PUT',
		path: '/admin/absences/{absencesId}',
		pathParams: ['absencesId'] as const,
		mutationOptions: () => ({
			mutationFn: (variables: {
				absencesId: number | string | null | undefined
				data: UpdateAbsenceRequest
			}) => absencesUpdate(variables.absencesId, variables.data),
		}),
		invalidates: [(_context) => getAbsencesListQueryKey()],
	}),
} as const
// #endregion

// #region Entity Config Export
export const absencesEntityConfig = {
	key: 'absences',
	kind: 'entity',
	entity: {
		idField: 'id',
		idParam: 'absencesId',
		routePath: '/absences',
	},
	endpoints: absencesEntityEndpoints,
} as const satisfies EntityConfig<'absences'>
// #endregion
